module.exports = __webpack_public_path__ + "img/info.7f704434.png";